import { baseAPI } from "../baseApi";

export const userInfoApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение информации о пользователе
        fetchUserInfo: builder.query<any, any>({
            query: () => ({
                url: `security/account/userInfo`
            }),
            transformResponse: (response: any) => {
                const newResponse: any = {}
                for (let key in response) {
                    newResponse[key] = (response[key as keyof any] !== undefined && response[key as keyof any]) ? response[key as keyof any] : "не указано"
                    if (response[key as keyof any] === 0) {
                        newResponse[key] = 0
                    }
                }
                return newResponse
            }
        }),
    })
})

export const {
    useFetchUserInfoQuery
} = userInfoApiSlice


